module.exports = __webpack_public_path__ + "img/banner-index-21.7c86f451.jpg";